import { AspConnection, AspConnectionsRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useFetchAspConnections() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);
  const [connections, setConnections] = useState<AspConnection[]>([]);

  async function fetchAspConnections(params: AspConnectionsRequest = {}) {
    try {
      setFetching(true);
      const res = await api.fetchAspConnections(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setConnections(res.Connections);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, connections, fetchAspConnections };
}
